<template>
  <div class="flex items-center justify-center">
    <img
      class="h-10 w-10 object-contain"
      src="@/assets/loader.gif"
      alt="Loading"
    >
  </div>
</template>
<script>
export default {
  name: "Loader",
};
</script>
 
<style scoped>
</style>